import { Team } from 'modules/teams/domain/interfaces/team';
import StageGroupEmpty from 'modules/championship/ui/components/form-parts/stages/stage-grid/stage-group/stage-group-empty';
import { TeamGroup } from 'modules/championship/domain/interfaces/team-group';
import StageGroup from './stage-group';

type StageGroupListProps = {
  groups: TeamGroup[];
  teams: Team[];
  onAddGroupClick?: () => void;
};

const StageGroupList = ({ groups, teams, onAddGroupClick }: StageGroupListProps) => {
  if (groups.length === 0) {
    return <StageGroupEmpty onAddClick={onAddGroupClick} />;
  }

  return (
    <div>
      {groups.map((group) => {
        const externallySelectedTeamIds = new Set(groups.filter((g) => g.id !== group.id).flatMap((g) => g.teams.map((t) => t.id)));

        return <StageGroup key={group.id} group={group} teams={teams} externallySelectedTeamIds={externallySelectedTeamIds} />;
      })}
    </div>
  );
};

export default StageGroupList;
